module.exports = __webpack_public_path__ + "img/qr.dc58af7b.jpg";